import { FilterConfig } from "../../../../components/Tables/advancedRecord/FilterBar";
import { DropdownDTO } from "../../../../types/common/DropdownDTO";

export const getPayableFilters = (
  suppliersDropdown: DropdownDTO[]
): FilterConfig[] => {
  return [
    // 🔍 Número
    {
      name: "number",
      label: "Número",
      type: "text",
      colSpan: 2,
    },

    // 👤 Proveedor
    {
      name: "supplierId",
      label: "Proveedor",
      type: "searchSelect",
      options: suppliersDropdown,
      colSpan: 4,
    },

    // 📅 Vencimiento desde
    {
      name: "dueDateFrom",
      label: "Vence desde",
      type: "date",
      colSpan: 3,
    },

    // 📅 Vencimiento hasta
    {
      name: "dueDateTo",
      label: "Vence hasta",
      type: "date",
      colSpan: 3,
    },
  ];
};